import { render, staticRenderFns } from "./BeingOverdue.vue?vue&type=template&id=4afee01c"
import script from "./BeingOverdue.vue?vue&type=script&lang=js"
export * from "./BeingOverdue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports